<main class="auth-page">
  <section class="auth-panel">
    <a class="brand" routerLink="/login">
      <img class="brand-logo" src="/brand/logo-horizontal.png" alt="ZepBazaar" />
      <strong>Business Portal</strong>
    </a>

    <div class="intro">
      <p>Business access</p>
      <h1>Sign in to manage your marketplace</h1>
    </div>

    @if (registrationMessage) {
      <p class="registration-success">{{ registrationMessage }}</p>
    }

    <form class="auth-form" #loginForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
      <label>
        <span>Email address</span>
        <input
          type="email"
          name="email"
          autocomplete="email"
          [(ngModel)]="credentials.email"
          placeholder="owner@business.in"
          required
          [disabled]="isSubmitting"
        />
      </label>

      <label>
        <span>Password</span>
        <input
          type="password"
          name="password"
          autocomplete="current-password"
          [(ngModel)]="credentials.password"
          placeholder="Enter password"
          required
          [disabled]="isSubmitting"
        />
      </label>

      <div class="form-row">
        <label class="check">
          <input
            type="checkbox"
            name="remember"
            [(ngModel)]="credentials.remember"
            [disabled]="isSubmitting"
          />
          <span>Remember me</span>
        </label>

        <a routerLink="/forgot-password" [queryParams]="{ portal: 'business', email: credentials.email }">Forgot password?</a>
      </div>

      @if (errorMessage) {
        <p class="form-error">{{ errorMessage }}</p>
      }

      <button class="primary" type="submit" [disabled]="isSubmitting">
        <span class="material-symbols-outlined" aria-hidden="true">
          {{ isSubmitting ? 'progress_activity' : 'login' }}
        </span>

        {{ isSubmitting ? 'Signing in...' : 'Sign in' }}
      </button>
    </form>

  </section>

  <section class="auth-aside" aria-label="New business onboarding">
    <div class="aside-copy">
      <p>Grow with ZepBazaar</p>
      <h2>Bring your business online with one connected workspace.</h2>
      <span>Manage stores, staff, inventory, purchases and sales after your business is approved.</span>
    </div>

    <article class="onboarding-card">
      <span class="material-symbols-outlined" aria-hidden="true">storefront</span>
      <div>
        <small>NEW BUSINESS</small>
        <h3>Onboard your business</h3>
      <p>Verify your email, complete the application and upload documents. Choose a plan after approval.</p>
      </div>
      <a class="onboarding-action" routerLink="/onboard-business">
        Start onboarding
        <span class="material-symbols-outlined" aria-hidden="true">arrow_forward</span>
      </a>
    </article>
  </section>
</main>
